import { AbstractControl, FormGroup, ValidatorFn, ValidationErrors } from "@angular/forms";

export const DIAS = [
  "lunes",
  "martes",
  "miercoles",
  "jueves",
  "viernes",
  "sabado",
  "domingo",
] as const;

export type Dia = typeof DIAS[number];

function val(group: FormGroup, name: string): string {
  return group.get(name)?.value || "";
}

export const validateAgendaHorarios: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const group = control as FormGroup;
  const errors: ValidationErrors = {};

  for (const dia of DIAS) {
    const desde  = val(group, `${dia}Desde`);
    const hasta  = val(group, `${dia}Hasta`);
    const desde2 = val(group, `${dia}Desde2`);
    const hasta2 = val(group, `${dia}Hasta2`);

    const tieneTramo1     = !!desde && !!hasta;
    const tieneAlgoTramo2 = !!desde2 || !!hasta2;

    if (desde && !hasta)  errors[`${dia}Error1`] = true;
    if (!desde && hasta)  errors[`${dia}Error2`] = true;
    if (desde && hasta && desde >= hasta) errors[`${dia}Error3`] = true;

    if (desde2 && !hasta2) errors[`${dia}Error4`] = true;
    if (!desde2 && hasta2) errors[`${dia}Error5`] = true;
    if (desde2 && hasta2 && desde2 >= hasta2) errors[`${dia}Error6`] = true;

    if (tieneAlgoTramo2 && !tieneTramo1) errors[`${dia}Error7`] = true;

    if (tieneTramo1 && desde2 && hasta >= desde2) errors[`${dia}Error8`] = true;
  }

  return Object.keys(errors).length > 0 ? errors : null;
};
